<template>
    <div id="brandmark">
        <PricingHeader />
        <PricingContent />
        <!-- <Carousel /> -->
    </div>
</template>

<script>
    import PricingHeader from '@/components/Pricing/PricingHeader.vue';
    import PricingContent from '@/components/Pricing/PricingContent.vue';
    import Wizard from '@/components/Wizard.vue';
    // import Carousel from '@/components/Carousel.vue';

    console.log(process.env.NODE_ENV);

    export default {
        name: 'brandmark',

        data: function () {
            return {
                logos: [

                ],
            }
        },

        created(){
          this.logos= this.$store.getters.getLogosData;
        },

        methods: {
            auto_scale: function(index, factor, sloganfactor, iconfactor){
                this.logos[index].autoScale = false;
                this.logos[index].titleScale *= factor;

                console.log(index, factor, sloganfactor, iconfactor);

                if(sloganfactor){
                    this.logos[index].sloganScale *= sloganfactor;
                }
                else{
                    this.logos[index].sloganScale *= factor;
                }

                if(iconfactor){
                    this.logos[index].iconScale *= iconfactor;
                }
            }
        },

        components: {
            PricingHeader,
            PricingContent,
            // Carousel,
        },

    }
</script>

<style lang="scss">

    @font-face {
        font-family: 'Proxima Nova Rg';
        src: local('Proxima Nova Bold'), local('ProximaNova-Bold'),
        url('./fonts/subset-ProximaNova-Bold.woff2') format('woff2'),
        url('./fonts/subset-ProximaNova-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Proxima Nova Rg';
        src: local('Proxima Nova Regular'), local('ProximaNova-Regular'),
        url('./fonts/subset-ProximaNova-Regular.woff2') format('woff2'),
        url('./fonts/subset-ProximaNova-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Proxima Nova Rg';
        src: local('Proxima Nova Medium'), local('ProximaNova-Medium'),
        url('./fonts/ProximaNova-Medium.otf') format('otf');
        font-weight: 500;
        font-style: normal;
    }

    html {
        box-sizing: border-box;
        font-size: 10px;
        -ms-overflow-style: scrollbar;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
    }

    body {
        margin: 0;
        padding: 0;
        font-size: 1.6rem;
        color: #191919;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: 'Proxima Nova Rg', Helvetica, Arial, sans-serif;
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    // transition for vue
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }


</style>
